import it from '../../translation/it_IT'

export default {
  // i18nConfiguration
  i18n: {
    locales: [
      {
        code: 'it',
        iso: 'it-CH',
      },
    ],
    defaultLocale: 'it',
    vueI18n: {
      fallbackLocale: 'it',
      messages: {
        it,
      },
    },
    pages: {
      'categories/business': {
        it: '/business',
      },
      'categories/get-inspired': {
        it: '/lasciati-ispirare',
      },
      'categories/how-to': {
        it: '/come-si-fa',
      },
      'categories/news': {
        it: '/le-novita',
      },
      'categories/printstories': {
        it: '/printstories',
      },
      'editorial-staff/index': {
        it: '/redazione',
      },
      'editorial-staff/_author': {
        it: '/redazione/:author?',
      },
    },
  },
  /* 
    Categories Configuration
    @order: [] è l'array delle chiavi delle categorie e rappresenta l'ordine con cui verranno visualizzate le categorie dove richieste
    list{
        @key è la chiave della categoria. Per convenzione chiamata come il folder dentro page.
        {
          @slug è lo slug della categoria inserito in categorie su Wordpress
          @view è la view di nuxt e corrisponde al name utilizzato nei nuxt-link
        }
    }
  */
  pages: {
    // leggere README.md
    list: [
      {
        key: 'index', // Home per comodità la trattiamo come una categoria
        wpUri: '/',
      },
      {
        key: 'business',
        wpUri: '/business/',
      },
      {
        key: 'get-inspired',
        wpUri: '/lasciati-ispirare/',
      },
      {
        key: 'how-to',
        wpUri: '/come-si-fa/',
      },
      {
        key: 'news',
        wpUri: '/le-novita/',
      },
      {
        key: 'printstories',
        wpUri: '/printstories/',
      },
      {
        key: 'editorial-staff',
        wpUri: '/redazione/',
      },
    ],
  },
  categories: {
    // leggere README.md
    list: [
      {
        key: 'business',
        wpSlug: 'business',
        view: 'categories-business',
        wpCategoryId: 4096,
      },
      {
        key: 'get-inspired',
        wpSlug: 'lasciatiispirare',
        view: 'categories-get-inspired',
        wpCategoryId: 69,
      },
      {
        key: 'how-to',
        wpSlug: 'comesifa',
        view: 'categories-how-to',
        wpCategoryId: 67,
      },
      {
        key: 'news',
        wpSlug: 'lenovita',
        view: 'categories-news',
        wpCategoryId: 70,
      },
      {
        key: 'printstories',
        wpSlug: 'printstories',
        view: 'categories-printstories',
        wpCategoryId: 6980,
      },
      {
        key: 'highlights',
        wpSlug: 'highlights',
        view: null,
        wpCategoryId: 6979,
      },
      {
        key: 'business-growth',
        wpSlug: 'businessgrowth',
        view: null,
        wpCategoryId: 6978,
      },
    ],
  },
  pixartWebsite: 'https://it.pixartprinting.ch/',
  navigation: {
    primary: {
      order: ['business', 'printstories', 'how-to', 'get-inspired', 'news'],
    },
    // Categorie che vengono filtrate da eventuali elenchi (es. la lista delle categorie a cui appartiene un post)
    exclude: ['highlights', 'business-growth'],
  },
  social: [
    {
      key: 'facebook',
      url: 'https://www.facebook.com/pixartprinting.it/',
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/pixartprinting/',
    },
    {
      key: 'linkedin',
      url: 'https://www.linkedin.com/company/pixartprinting/',
    },
  ],
  terms: [
    {
      key: 'privacy-policy',
      url: 'https://it.pixartprinting.ch/privacy/',
    },
  ],
  shopLinks: [
    {
      label: 'Stampa online',
      url: 'https://it.pixartprinting.ch/',
    },
    {
      label: 'Biglietti da visita',
      url: 'https://it.pixartprinting.ch/biglietti-da-visita-personalizzati/',
    },
    {
      label: 'Volantini e flyer',
      url: 'https://it.pixartprinting.ch/piccolo-formato/stampa-flyer-volantini/',
    },
    {
      label: 'Etichette adesive',
      url: 'https://it.pixartprinting.ch/stampa-cartellini-etichette/',
    },
    {
      label: 'Adesivi personalizzati',
      url: 'https://it.pixartprinting.ch/stampa-cartellini-etichette/etichette-adesive/',
    },
    {
      label: 'Packaging',
      url: 'https://it.pixartprinting.ch/packaging/',
    },
    {
      label: 'Scatole personalizzate',
      url: 'https://it.pixartprinting.ch/packaging/scatole-personalizzate/',
    },
    {
      label: 'Shopper e buste',
      url: 'https://it.pixartprinting.ch/shopper-buste-personalizzate/',
    },
    {
      label: 'Riviste, libri e cataloghi',
      url: 'https://it.pixartprinting.ch/stampa-riviste-cataloghi-libri/',
    },
    {
      label: 'Stampa su tela',
      url: 'https://it.pixartprinting.ch/stampa-riviste-cataloghi-libri/',
    },
    {
      label: 'Gadget',
      url: 'https://it.pixartprinting.ch/gadget-personalizzati/',
    },
    {
      label: 'Calendari e agende',
      url: 'https://it.pixartprinting.ch/calendari/',
    },
  ],
  nuxtConfiguration: {
    head: {},
  },
}
